import DOMPurify from 'dompurify';

// Renders a snippet of Jira-style rich text (HTML with <br>, <b>, lists, links,
// HTML entities, etc.) into a sanitized HTML string safe for
// dangerouslySetInnerHTML. Jira returns description/expectedResult fields as
// HTML fragments; rendering them as plain text leaves visible markup like
// "<br>" and "&gt;".

export const CONFIG = {
  ALLOWED_TAGS: [
    'br', 'p', 'div', 'span',
    'b', 'strong', 'i', 'em', 'u', 's', 'strike', 'del', 'mark', 'small', 'sub', 'sup',
    'ul', 'ol', 'li',
    'a', 'code', 'pre', 'kbd', 'tt',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'hr',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
  ],
  ALLOWED_ATTR: ['href', 'title'],
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function renderJiraHtml(html) {
  if (html == null || html === '') return '';
  return DOMPurify.sanitize(String(html), CONFIG);
}
